import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  errorApp: ['error'],
});

const INITIAL_STATE = Immutable({
  error: {},
});

const errorApp = (state, { error }) => state.set('error', error);

export default createReducer(INITIAL_STATE, {
  [Types.ERROR_APP]: errorApp,
});
